import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMessage(err) {
  return formatApiErrorDetail(err?.response?.data?.detail) || err?.message || "Request failed";
}

export const ORG_LOGOS = {
  // Official authority seals — served from /app/frontend/public/seals/.
  // These are the same PNGs used on certificates and the registry's
  // <Seal /> component, so brand identity is unified across the entire app.
  ACIS: "/seals/acis-accredited-member.png",
  IBTHM: "/seals/ibthm-board-certified.png",
};

export const INSTITUTION_IMG =
  "https://images.unsplash.com/photo-1769698678497-c41f0ab47c3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtZWRpY2FsJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwwfHx8fDE3ODAyMTIyNTN8MA&ixlib=rb-4.1.0&q=85";
